import ProfileDetailUserDataSubAccountsView from './ProfileDetailUserDataSubAccountsView';

export default ProfileDetailUserDataSubAccountsView;
